import instance from "@/services/api";

export const floorParamTypesAPI = {
  async getFloorParamTypes(params) {
    return await instance()
      .get("/project_list/floor_params/type/read/", { params })
      .then((res) => res?.data);
  },
  async updateFloorParamType(body, params) {
    return await instance()
      .post("/project_list/floor_params/type/update/", body, { params })
      .then((res) => res?.data);
  },
  async getParams(params) {
    return await instance()
      .get("/project_list/floor_params/get_params/", { params })
      .then((res) => res?.data);
  },
  async getUnits(params) {
    return await instance()
      .get("/material/unit/", { params })
      .then((res) => res?.data);
  },
  async deleteFloorParamType(floor_param_type_id) {
    return await instance()
      .delete(`/project_list/floor_params/type/${floor_param_type_id}/delete/`)
      .then((res) => res?.data);
  },
};
export const projectLinkAPI = {
  async getProjectLinks(params) {
    return await instance()
      .get("/project_list/floor_params/project_link/", { params })
      .then((res) => res?.data);
  },
  async updateProjectLink(body, params) {
    return await instance()
      .post("/project_list/floor_params/project_link/update/", body, { params })
      .then((res) => res?.data);
  },
  async bulkUpdateProjectLink(body) {
    return await instance()
      .post("/project_list/floor_params/project_link/bulk_update/", body)
      .then((res) => res?.data);
  },

  async getFloorParamTypesForSelect(params) {
    return await instance()
      .get("/project_list/floor_params/param_types/all/read/", { params })
      .then((res) => res?.data);
  },
  async deleteProjectLink(floor_param_project_link_id) {
    return await instance()
      .delete(
        `/project_list/floor_params/project_link/${floor_param_project_link_id}/delete/`
      )
      .then((res) => res?.data);
  },
};

export const paramLinkAPI = {
  async getParamLinks(params) {
    return await instance()
      .get("/project_list/floor_params/param_link/", { params })
      .then((res) => res?.data);
  },

  async updateParamLink(body, params) {
    return await instance()
      .post("/project_list/floor_params/param_link/update/", body, { params })
      .then((res) => res?.data);
  },
  async deleteParamLink(param_id) {
    return await instance()
      .delete(`/project_list/floor_params/param_link/${param_id}/delete/`)
      .then((res) => res?.data);
  },

  async getFloorPlanTypes() {
    return await instance()
      .get("/project_list/floor_params/param_list/read/")
      .then((res) => res?.data);
  },
  async updateFloorPlanType(body) {
    return await instance()
      .post("/project_list/floor_params/param/update/", body)
      .then((res) => res?.data);
  },
  async deleteFloorPlanType(param_id) {
    return await instance()
      .delete(`/project_list/floor_params/param/${param_id}/delete/`)
      .then((res) => res?.data);
  },
  async getParamTypes(floor_param_type_id) {
    return await instance()
      .get(`/project_list/floor_params/project_link/read_type/`, {
        params: { floor_param_type_id }
      })
      .then((res) => res?.data);
  },
  async getParamValueLinks(param_id) {
    return await instance()
      .get("/project_list/floor_params/param_value_link/read/", {
        params: { param_id },
      })
      .then((res) => res?.data);
  },
  async updateParamValueLink(body) {
    return await instance()
      .post("/project_list/floor_params/param_value_link/update/", body)
      .then((res) => res?.data);
  },
  async deleteParamValueLink(param_value_link_id) {
    return await instance()
      .delete(`/project_list/floor_params/param_value_link/${param_value_link_id}/delete/`)
      .then((res) => res?.data);
  },
  async getParamValueLinkStat() {
    return await instance()
      .get("/project_list/floor_params/param_value_link/stat/read/")
      .then((res) => res?.data);
  },
};
